<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{ this.$route.name }}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberEntry/editPtSession?id=' + $route.query.id + '&member_id=' + $route.query.member_id)"
              class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
          <div class="col-md-6 text-right">
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <div class="mb-40">
              <div class="title font-300 font-20 mb-15">
                Current Session
              </div>
              <table class="table border-table">
                <thead>
                  <tr>
                    <th>TRX ID</th>
                    <th>Session Name</th>
                    <th>Qty</th>
                    <th>Revenue</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ currentData.trx_id }}</td>
                    <td>{{ currentData.pt_session ? currentData.pt_session.name : '-' }}</td>
                    <td>{{ currentData.current_session_qty }}</td>
                    <td>{{ totalRevenue }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-sm-10">
            <hr>
            <div class="title font-300 font-20 mb-15">
              New Session
            </div>
            <form @submit.prevent="submitData" class="mt-30">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Session</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select @change="getPtSessionData" class="border-bottom" name="pt_session"
                    v-validate="'required'" v-model="editData.pt_session_id">
                    <option :value="null">Please select</option>
                    <option v-for="itemSession in itemPtSession" :key="itemSession.id" :value="itemSession.id">
                      {{ itemSession.name }}
                    </option>
                  </b-form-select>
                  <span class="error">{{ errors.first('pt_session') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Total Session</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input :disabled="!editData.pt_session_id" :value="totalSession" v-model="editData.total_session" name="total_session" v-validate="'required|numeric'"
                    type="text"></b-form-input>
                  <span class="error">{{ errors.first('total_session') }}</span>
                </b-col>
              </b-row>

              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Total Revenue</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input readonly :value="totalRevenueNew" name="total_revenue_new"
                    type="text">
                  </b-form-input>
                </b-col>
              </b-row>

              <div class="text-right mb-20">
                <!-- <button :disabled="disabledExpiredDate" type="submit" class="btn-primary">Submit</button> -->
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'addPtSession',
  components: {
    'app-pagination': Pagination
  },
  data: function () {
    return {
      loadingActive: false,
      currentData: {},
      totalRevenue: 0,
      totalRevenueNew: 0,
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      itemPt: [],
      itemPtSession: [],
      itemListEdit: [],
      paradigm_role_id: Auth.Session.get().paradigm_role,
      editData: {
        pt_session_id: null,
        total_session: 1
      },
      config: {
        altInput: true,
        altFormat: 'j F Y H:i',
        dateFormat: 'Y-m-d H:i',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      config2: {
        altInput: true,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d',
        enableTime: false
      },
      config3: {
        altInput: false,
        altFormat: 'j F Y',
        dateFormat: 'Y-m-d',
        enableTime: false
      },
      disabledEpiredDate: false,
      detailPtSession: [],
      selectedPtSession: null
    }
  },
  methods: {
    onChangeTotalSession() {
      console.log(this.editData.total_session)
    },
    getPtSessionData(event) {
      const find = this.itemPtSession.find((m) => m.id === event)
      console.log(find)
      if (find) {
        this.selectedPtSession = find
      }
      
    },
    disabledBackDate() {
      // disable if month is more than current month
      // this.disabledEpiredDate = true
      const year = moment().format('YYYY')
      const month = moment().format('M')

      axios.get('crm/v1/closing_period/member_pt_session?year=' + year + '&bulan=' + month).then(response => {
        const data = response.data.data
        if (data) {
          this.disabledEpiredDate = true
        }
      }).catch(error => {
        this.disabledEpiredDate = false
        console.log('error', error)
      })
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    parseDate(event) {
      return moment(event).format('DD MMMM YYYY')
    },
    submitData() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Send it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          this.loadingActive = true
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.editData.trx_id = this.currentData.trx_id
              console.log(this.editData)
                axios.post('fitness/v1/member_pt_session/member_entry/add_new_pt_session', this.editData).then(response => {
                  console.log('test', response)
                  this.$router.push('/memberEntry/edit?id=' + this.$route.query.member_id)
                  this.$toast.success('data saved successfully!', 'Success', {
                    position: 'topCenter',
                    icon: 'icon-envelope',
                    progressBarColor: 'rgb(0, 255, 184)',
                    theme: 'dark',
                    backgroundColor: '#565c70',
                    messageColor: '#fff'
                  })
                  this.loadingActive = false
                }).catch(error => {
                  console.log('error log', error)
                  this.$toast.success('cant saved data!', 'Error', {
                    position: 'topCenter',
                    icon: 'icon-envelope',
                    progressBarColor: 'rgb(0, 255, 184)',
                    theme: 'dark',
                    backgroundColor: '#565c70',
                    messageColor: '#fff'
                  })
                  this.loadingActive = false
                })
              } else {
                this.loadingActive = false
                this.$toast.success('please fill in required fields!', 'Error', {
                  position: 'topCenter',
                  icon: 'icon-envelope',
                  progressBarColor: 'rgb(0, 255, 184)',
                  theme: 'dark',
                  backgroundColor: '#565c70',
                  messageColor: '#fff'
                })
              }
            
          })
        }
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    fetchData() {
      axios.get('fitness/v1/personal_training/').then(response => {
        this.itemPt = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/pt_session?sorting=name&sorting_type=asc').then(response => {
        this.itemPtSession = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/member_pt_session/' + this.$route.query.id).then(response => {
        // console.log(response.data.data)
        this.currentData = response.data.data
        this.totalRevenue = 'Rp. ' + parseFloat(this.currentData.current_session_qty * (this.currentData.pt_session ? this.currentData.pt_session.price : 0)).toLocaleString('id-ID', {maximumFractionDigits:2})
        // this.editData.member_id = response.data.data.member_id
        // this.editData.buy_session_qty = response.data.data.buy_session_qty
        // this.editData.personal_trainer_id = response.data.data.personal_trainer_id
        // this.editData.created_at = response.data.data.created_at
        // this.editData.expired_at = response.data.data.expired_at
        // this.editData.current_session_qty = response.data.data.current_session_qty
        // this.editData.is_active = response.data.data.is_active
        // this.editData.update_exp_1 = response.data.data.update_exp_1
        // this.editData.update_exp_2 = response.data.data.update_exp_2

        axios.get('fitness/v1/member_pt_session/running/' + response.data.data.trx_id + '?page=' + this.currentPage + '&limit=' + this.paginationLimit).then(response => {
          this.itemListEdit = response.data.data.rows
          this.totalPage = response.data.meta.pageCount
          // console.log('test', this.itemListEdit)
        }).catch(error => {
          console.log('error', error)
        })
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    totalSession: function() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.totalRevenueNew = 'Rp. ' + parseFloat(this.editData.total_session * (this.selectedPtSession ? this.selectedPtSession.price : 0)).toLocaleString('id-ID', {maximumFractionDigits:2})
    }
  }
}
</script>

<style></style>
